import React, { useEffect } from 'react';
import { OktaAuth } from '@okta/okta-auth-js';
import { tokenManager } from '../utils/tokenManager';

interface OktaLoginProps {
  oktaAuth: OktaAuth;
}

const OktaLogin: React.FC<OktaLoginProps> = ({ oktaAuth }) => {
    useEffect(() => {
        const login = async () => {
          try {
            tokenManager.setAuthType('okta');
            await oktaAuth.signInWithRedirect({
              originalUri: '/dashboard'
            });
          } catch (error) {
            console.error('Error during Okta login:', error);
            tokenManager.setAuthType(null);
          }
        };
   
        login();
    }, [oktaAuth]);

    return <div>Redirecting to Okta login...</div>;
};

export default OktaLogin;